/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCDownIcon16Solid = forwardRef('ArrowCDownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.616 5.116a1.25 1.25 0 0 1 1.768 0L8 8.732l3.616-3.616a1.25 1.25 0 0 1 1.768 1.768L9.59 10.677a2.25 2.25 0 0 1-3.182 0L2.616 6.884a1.25 1.25 0 0 1 0-1.768Z" })));
});
